import React, { useState, useEffect } from "react";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import TodayIcon from "@mui/icons-material/Today";
import DateRangeIcon from "@mui/icons-material/DateRange";
import SortIcon from "@mui/icons-material/Sort";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import ClearIcon from "@mui/icons-material/Clear";
import dayjs from "dayjs";
import { range } from "lodash";
import { Stack, Typography } from "@mui/material";
import axios from "axios";

import { CONFIG } from "../../../config";
import { useSelector } from "react-redux";
import CurrentAttendanceDetails from "./components/current-attendance-details";

const API_HOST_CRM = CONFIG.modules["accounts"].host;


function AttendanceDetails({ type, filter, selectedUser, map, attendanceByMonth, attendanceByUser }) {
  const { users } = useSelector(state => state.user || {});

  let today = dayjs().format('YYYY-MM-DD')

  const [currentAttendanceDetails, setCurrentAttendanceDetails] = useState(null);
  const [currentAttendanceDetailsLoading, setCurrentAttendanceDetailsLoading] = useState(false);

  const getCurrentAttendanceDetails = async () => {
    try {
      setCurrentAttendanceDetailsLoading(true);
      const response = await axios.get(`${API_HOST_CRM}/get-attendance-details?userId=${selectedUser._id}`);

      console.log(response, "response")
      if (response.data.success) {
        if (response.data.attendance) {
          setCurrentAttendanceDetails(response.data.attendance);
        }
      }
    } catch (error) {
      console.log(error, "error")
    } finally {
      setCurrentAttendanceDetailsLoading(false);
    }
  }

  useEffect(() => {
    if (selectedUser?._id) {
      getCurrentAttendanceDetails();
    }
  }, [selectedUser])

  const daily = () => {
    return (
      <div className="border rounded p-3">
        <div className="">
          <div className="d-flex justify-content-between">
            <div className="bg-light p-2 rounded pr-5">
              <>
                <div className="text-dark">
                  <CalendarMonthIcon fontSize="medium" /> Month :{" "}
                  <span className="font-weight-bold"> {dayjs(filter.date).format('MMMM')} </span>{" "}
                </div>
                <div className="text-dark">
                  <DateRangeIcon fontSize="medium" /> Date :{" "}
                  <span className="font-weight-bold"> {dayjs(filter.date).format('DD-MM-YYYY  ')} </span>{" "}
                </div>
              </>
            </div>
            {
              selectedUser &&
              <div className="bg-light p-2 rounded pr-5">
                <div>
                  <span>Employee Name: </span>
                  <span className="font-weight-bold">{selectedUser.name}</span>
                </div>
                <div>
                  <span>Designation: </span>
                  <span className="font-weight-bold">{
                    Array.isArray(selectedUser?.roles) && selectedUser.roles.map((r, i) => {
                      const m = map.Roles;
                      return (
                        <span>
                          {`${m[r]?.name}`}
                          {selectedUser?.roles.length !== i + 1 ? ", " : ""}
                        </span>
                      );
                    })

                  }</span>
                </div>
                <div>
                  <span>Department: </span>
                  <span className="">{
                    Array.isArray(selectedUser?.departments) && selectedUser.departments.map((d, i) => {
                      let r;
                      if (typeof d == "object") {
                        r = d._id;
                      } else {
                        r = d;
                      }
                      const m = map.Departments;
                      return (
                        <span
                          className={`text-${m[r]?.type == "Core" ? "success" : "primary"
                            }`}
                        >
                          {`${m[r]?.name}`}
                          {selectedUser?.departments.length !== i + 1 ? ", " : ""}
                        </span>
                      );
                    })
                  }
                  </span>
                </div>
              </div>
            }


          </div>
        </div>
        <Stack component={"section"} id="current-attendance-details" className="bg-light" my={1} p={2}>
          <CurrentAttendanceDetails getCurrentAttendanceDetails={getCurrentAttendanceDetails} currentAttendanceDetails={currentAttendanceDetails} currentAttendanceDetailsLoading={currentAttendanceDetailsLoading} />
        </Stack>
        <div className="border mt-2">
          <div className="text-center font-weight-bold bg-light p-2">
            {dayjs(filter.date).format('MMMM')}
          </div>
          <hr className="p-0 m-0" />
          <div>
            <div className="col-12">
              <div className="row p-0 m-0">
                <div className="col-4 bg-light rounded p-2 pl-3">
                  <div>
                    <div className="text-secondary">Remarks: </div>
                    <div className="">No remarks Found </div>
                  </div>
                </div>

                <div className="col-7 p-1 m-0 d-flex flex-wrap ">
                  {
                    range(1, dayjs(filter.date).daysInMonth() + 1).map((d, i) => {
                      const currentDate = dayjs(`${d}-${dayjs(filter.date).month() + 1}-${dayjs(filter.date).year()}`, 'D-M-YYYY').format('DD/MM/YYYY')


                      const future = dayjs(`${d}-${dayjs(filter.date).month() + 1}-${dayjs(filter.date).year()}`, 'D-M-YYYY').isAfter(dayjs())
                      const absent = !future && ((attendanceByMonth[i] && attendanceByMonth[i].status == "absent")
                        || (!attendanceByMonth[d] &&
                          dayjs(`${i}-${dayjs(filter.date).month() + 1}-${dayjs(filter.date).year()}`, 'D-M-YYYY').isBefore(dayjs())))

                      const onLeave = attendanceByMonth[d] && attendanceByMonth[d].status == "leave";
                      //  console.log(i,currentDate, future, absent, onLeave )
                      return (
                        <>
                          {absent &&
                            <div className="p-1" style={{ width: "14%" }}>
                              <div className="bg-warning rounded text-center" style={{ color: 'white' }}>{d}</div>
                            </div>
                          }
                          {onLeave &&
                            <div className="p-1" style={{ width: "14%" }}>
                              <div className="bg-danger rounded text-center" style={{ color: 'white' }}>{d}</div>
                            </div>
                          }
                          {future &&
                            <div className="p-1" style={{ width: "14%" }}>
                              <div className="bg-light rounded text-center" >{d}</div>
                            </div>
                          }
                          {
                            attendanceByMonth[d] && attendanceByMonth[d].status == "present" &&
                            <div className="p-1" key={i} style={{ width: "14%" }}>
                              <div className="bg-success rounded text-center" style={{ color: 'white' }}>{d}</div>
                            </div>
                          }
                        </>
                      )
                    })
                  }


                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const week = () => {
    return (
      <div className="border rounded p-3">
        <div className="">
          <div className="d-flex justify-content-between">
            <div className="bg-light p-2 rounded pr-5">
              <>

                <div className="text-dark">
                  <CalendarMonthIcon fontSize="medium" /> Month :{" "}
                  <span className="font-weight-bold"> {dayjs(filter.from).format('MMMM ')} </span>{" "}
                </div>
                <div className="text-dark">
                  <DateRangeIcon fontSize="medium" /> Date Range :{" "}
                  <span className="font-weight-bold">
                    {" "}
                    {dayjs(filter.from).format('DD-MM-YYYY')} to {dayjs(filter.to).format('DD-MM-YYYY')}
                  </span>{" "}
                </div>
              </>
            </div>
            {
              selectedUser &&
              <div className="bg-light p-2 rounded pr-5">
                <div>
                  <span>Employee Name: </span>
                  <span className="font-weight-bold">{selectedUser.name}</span>
                </div>
                <div>
                  <span>Designation: </span>
                  <span className="font-weight-bold">{
                    Array.isArray(selectedUser?.roles) && selectedUser.roles.map((r, i) => {
                      const m = map.Roles;
                      return (
                        <span>
                          {`${m[r]?.name}`}
                          {selectedUser?.roles.length !== i + 1 ? ", " : ""}
                        </span>
                      );
                    })

                  }</span>
                </div>
                <div>
                  <span>Department: </span>
                  <span className="font-weight-bold">{
                    Array.isArray(selectedUser?.departments) && selectedUser.departments.map((d, i) => {
                      let r;
                      if (typeof d == "object") {
                        r = d._id;
                      } else {
                        r = d;
                      }
                      const m = map.Departments;
                      return (
                        <span
                          className={`text-${m[r]?.type == "Core" ? "success" : "primary"
                            }`}
                        >
                          {`${m[r]?.name}`}
                          {selectedUser?.departments.length !== i + 1 ? ", " : ""}
                        </span>
                      );
                    })
                  }</span>
                </div>
              </div>
            }

          </div>
        </div>

        <div className="border mt-2">
          <div className="text-center font-weight-bold bg-light p-2">
            {dayjs(filter.from).format('MMMM')}
          </div>
          <hr className="p-0 m-0" />
          <div>
            <div className="col-12">
              {
                range(0, dayjs(filter.to).diff(dayjs(filter.from), 'day') + 1).map((d, i) => {
                  const f = attendanceByUser[dayjs(filter.from).add(d, 'day').format('DD-MM-YYYY')]
                  console.log(f, dayjs(filter.from).add(d, 'day').format('DD-MM-YYYY'))
                  return (
                    <div className="row" key={i}>
                      <div className="col-3 bg-light rounded border-right p-2 mb-2">
                        <div>
                          <div className="text-white text-center bg-secondary">
                            {dayjs(filter.from).add(d, 'day').format('MMMM D')}{" "}
                          </div>
                          <div className="text-center ">Check in </div>
                          <div className="text-center ">Check out </div>
                        </div>
                      </div>
                      <div className="col-3 bg-light rounded border-right p-2 mb-2">
                        {
                          f && f.status == 'present' &&
                          <div>
                            <div className="text-center ">
                              {" "}
                              <CheckBoxIcon color="success" />{" "}

                            </div>
                            <div className="text-center "> {dayjs(f.checkIn).format('HH:mm')} </div>
                            <div className="text-center "> {f.lastCheckOut ? dayjs(f.lastCheckOut).format('HH:mm') : '-'} </div>
                          </div>
                        }
                        {
                          f && f.status == 'absent' &&
                          <div>
                            <div className="text-center ">
                              {" "}
                              <ClearIcon color="error" />{" "}

                            </div>
                            <div className="text-center "> - </div>
                            <div className="text-center "> - </div>
                          </div>
                        }
                        {
                          f && f.status == 'leave' &&
                          <div>
                            <div className="text-center ">
                              {" "}
                              <ClearIcon color="error" />{" "}

                            </div>
                            <div className="text-center "> - </div>
                            <div className="text-center "> - </div>
                          </div>
                        }
                        {
                          !f && dayjs(filter.from).add(d, 'day').isBefore(dayjs().add(1, 'day')) &&
                          <div>
                            <div className="text-center ">
                              {" "}
                              <ClearIcon color="error" />{" "}
                            </div>
                            <div className="text-center "> - </div>
                            <div className="text-center "> - </div>
                          </div>
                        }

                      </div>
                      <div className="col-6 bg-light rounded border-right p-2 mb-2">
                        <div>
                          <div className="text-secondary">Remarks: </div>
                          {
                            f && f.status == 'present' &&
                            <div> Present </div>
                          }
                          {
                            f && f.status == 'absent' &&
                            <div> Absent </div>
                          }
                          {
                            f && f.status == 'leave' &&
                            <div> On leave </div>
                          }
                          {
                            !f && dayjs(filter.from).add(d, 'day').isBefore(dayjs().add(1, 'day')) &&
                            <div> Absent </div>
                          }

                        </div>
                      </div>
                    </div>
                  )
                })
              }


              {/* <div className="row">
                <div className="col-3 bg-light rounded border-right p-2 mb-2">
                  <div>
                    <div className="text-white text-center bg-secondary">
                      January 3{" "}
                    </div>
                    <div className="text-center ">Check in </div>
                    <div className="text-center ">Check out </div>
                  </div>
                </div>
                <div className="col-3 bg-light rounded border-right p-2 mb-2">
                  <div>
                    <div className="text-center ">
                      {" "}
                      <ClearIcon color="error" />{" "}
                    </div>
                    <div className="text-center "> - </div>
                    <div className="text-center "> - </div>
                  </div>
                </div>
                <div className="col-6 bg-light rounded border-right p-2 mb-2">
                  <div>
                    <div className="text-secondary">Remarks: </div>
                    <div> On sick leave </div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-3 bg-light rounded border-right p-2 mb-2">
                  <div>
                    <div className="text-white text-center bg-secondary">
                      January 2{" "}
                    </div>
                    <div className="text-center ">Check in </div>
                    <div className="text-center ">Check out </div>
                  </div>
                </div>
                <div className="col-3 bg-light rounded border-right p-2 mb-2">
                  <div>
                    <div className="text-center ">
                      {" "}
                      <CheckBoxIcon color="success" />{" "}
                    </div>
                    <div className="text-center "> 10:45 </div>
                    <div className="text-center "> 19:00 </div>
                  </div>
                </div>
                <div className="col-6 bg-light rounded border-right p-2 mb-2">
                  <div>
                    <div className="text-secondary">Remarks: </div>
                    <div> Late </div>
                  </div>
                </div>
              </div> */}

            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      {type === "daily" && <div>{daily()}</div>}
      {type === "week" && <div>{week()}</div>}
    </div>
  );
}

export default AttendanceDetails;
